import React, { useContext } from 'react';
import { ReactComponent as PauseParcela } from '../../../../assets/novosicones/Financeiro/pause.svg';
import styled from 'styled-components';
import { ContextoFinanceiro } from '../../../../services/financeiro';
import verificaSeParcelaAtrasada from '../../../../Utils/checkIfBillIsLate';

const BtnPauseParcela = styled.span`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d1d1d1;
  padding: 2px;
  margin-right: 13px;
  margin-left: 0px;
  border-radius: 4px;
`;

const BtnSelecionarParcela = ({
  index,
  setParcelasSelecionadas,
  parcelasSelecionadas,
  parcela,
  temBoleto,
  exibirGeraBoleto,
  parcelasAPagar,
  temCartao,
  temPix,
}) => {
  let estiloBotao = {};
  let btnDesabilitado = '';

  const { setParcelaBloqueadaClicada } = useContext(ContextoFinanceiro);

  function verificaSeParcelaSelecionada(id) {
    let index = parcelasSelecionadas?.findIndex(
      (val) => val.parcela.idReceber == id
    );

    if (index < 0) {
      return false;
    } else {
      return true;
    }
  }

  const returnExpiredBill = () => {
    const teste = parcelasSelecionadas?.find((parc) =>
      verificaSeParcelaAtrasada(parc.parcela.dataVencimento)
    );
    return teste;
  };

  const validBill = () => {
    const teste = parcelasSelecionadas?.find(
      (parc) => !verificaSeParcelaAtrasada(parc.parcela.dataVencimento)
    );

    return teste;
  };

  // se parcela atrasada e existe alguma selecionada que não está atrasada ->desabilita botao
  //  se parcela NãO atrasada e exite alguma selecionada que esta atrasada -> desabilita botao

  if (
    temBoleto ||
    !exibirGeraBoleto ||
    temCartao ||
    temPix ||
    (verificaSeParcelaAtrasada(parcela?.dataVencimento) && validBill()) ||
    (!verificaSeParcelaAtrasada(parcela?.dataVencimento) && returnExpiredBill())
  ) {
    btnDesabilitado = true;
  } else {
    btnDesabilitado = false;
  }

  function getParcelaObrigatoria(parcObrigatorias) {
    let arrParcObrigatorias = [];
    for (let eachParcela of parcObrigatorias) {
      parcelasAPagar.filter((p) => {
        if (p.numeroParcelaGeral == eachParcela) {
          arrParcObrigatorias.push({
            parcela: p,
            index: p.idReceber,
          });
        }
      });
    }

    return arrParcObrigatorias;
  }

  function removerParcelaSelecionada(arrId) {
    arrId.sort();

    let tempSelecionadas = parcelasSelecionadas;

    for (let a of arrId) {
      tempSelecionadas = tempSelecionadas.filter(
        (item) =>
          item.parcela.numeroParcelaGeral != a && item.parcela.idReceber != a
      );
    }

    return tempSelecionadas;
  }

  function removeParcela() {
    let tempArrToRemove = [];
    tempArrToRemove.push(index);

    if (parcela.grupoObrigatorio.length > 0) {
      tempArrToRemove.push(...parcela.grupoObrigatorio);

      let tempResult = removerParcelaSelecionada(tempArrToRemove);
      if (tempResult.length == 0) setParcelasSelecionadas([]);
      else setParcelasSelecionadas(tempResult);
    } else {
      setParcelasSelecionadas(removerParcelaSelecionada([index]));
    }
  }

  function addRemoveParcela() {
    // se existir somente uma parcela selecionada e a parcela clicada é a selecionada, seta array de parcelas selecionadas com um array vazio  >>>>>>>>OK
    if (
      parcelasSelecionadas.length == 1 &&
      verificaSeParcelaSelecionada(index)
    ) {
      setParcelasSelecionadas([]);
    } else {
      // se a parcela clicada extá selecionada, vai remover a  parcela ao array de parcelas selecionadas
      if (verificaSeParcelaSelecionada(index)) {
        removeParcela();
      }
      // se a parcela clicada NÃO extá selecionada, vai remover a  parcela do array de parcelas selecionadas >>>>>> OK
      else {
        addParcela();
      }
    }
  }

  function addParcela() {
    if (parcela.grupoObrigatorio.length > 0) {
      let temp = [];

      temp = getParcelaObrigatoria(parcela.grupoObrigatorio);

      temp.push({ parcela, index });

      setParcelasSelecionadas([...parcelasSelecionadas, ...temp]);
    } else {
      setParcelasSelecionadas([
        ...parcelasSelecionadas,
        { parcela, index: index },
      ]);
    }
  }

  return (
    <>
      {btnDesabilitado && !temBoleto && (
        <BtnPauseParcela
          onClick={() => {
            setParcelaBloqueadaClicada(parcela.idReceber);
          }}
        >
          <PauseParcela style={{ fill: '#d1d1d1' }} />
        </BtnPauseParcela>
      )}
      {btnDesabilitado && temBoleto && (
        <input
          name='checkedB'
          className='cardParcelas__detalhes__btnSelecionarParcela centralized'
          color='default'
          onChange={() => {
            addRemoveParcela();
          }}
          type='checkbox'
          style={{ ...estiloBotao, cursor: 'auto !important' }}
          disabled
          id={index}
          checked={verificaSeParcelaSelecionada(index)}
        />
      )}
      {!btnDesabilitado && (
        <input
          name='checkedB'
          className='cardParcelas__detalhes__btnSelecionarParcela centralized'
          color='default'
          onChange={() => {
            addRemoveParcela();
          }}
          type='checkbox'
          style={{ ...estiloBotao, cursor: 'auto !important' }}
          disabled={btnDesabilitado}
          id={index}
          checked={verificaSeParcelaSelecionada(index)}
        />
      )}
    </>
  );
};

export default BtnSelecionarParcela;
